import type { FC } from 'react';
import type {
  Question,
  ResultsPageExitStrategyExtraCtaConfig,
  StudentLoansInlineDslContent,
} from '../../types/types';
import type { Result } from '../../types/result';
import type { SubmissionStatus } from '../ResultsPage/types';
import type { SubmissionStatusProps } from '../SubmissionStatus/types';

export enum SingleSubmissionStep {
  PII_CONFIRMATION = 'PII_CONFIRMATION',
  EXIT_STRATEGY = 'EXIT_STRATEGY',
  ADDITIONAL_QUESTIONS = 'ADDITIONAL_QUESTIONS',
}

export type SingleProgramSubmissionProps = {
  step: SingleSubmissionStep;
  selectedResult?: Result;
  startTime?: number;
  piiLeadErrors?: { field: string }[];
  editMode?: boolean;
  setEditMode?: (mode: boolean) => void;
  degree?: string;
  isLoading?: boolean;
  leadSubmissionStatus?: SubmissionStatus;
  setLeadSubmissionStatus: (status: SubmissionStatus) => void;
  canSubmit?: boolean;
  formHeading?: string;
  formSubHeading?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  setFirstName: (value: string) => void;
  setLastName: (value: string) => void;
  setEmail: (value: string) => void;
  setPhone: (value: string) => void;
  formErrors: { field: string }[];
  setFormErrors?: (errors: { field: string }[]) => void;
  questions?: Question[];
  onProgramSubmit: (formData?: any) => void;
  onNextSteps?: () => void;
  onBackButtonClick?: () => void;
  onCloseExperience?: () => void;
  productClickedCorrelationId: string;
  submittedResults?: { programId?: number; schoolId?: string }[];
  SubmissionStatusComponent?: FC<SubmissionStatusProps>;
  /**
   * DSL result-step config id, forwarded to `PiiConfirmation` →
   * `PiiFormSection` so the governed DSL lead funnel carries
   * `dslConfigId`. Absent on the imperative path.
   */
  dslConfigId?: string;
  studentLoansInlineContent?: StudentLoansInlineDslContent;
  extraCtaConfig?: ResultsPageExitStrategyExtraCtaConfig;
  /**
   * Generic partner identifiers read off the LDS v4 submit response
   * (EDUN-14483), e.g. `{ referenceId, studentId }`. Forwarded to the
   * `EXIT_STRATEGY` step's CTA interpolation sources alongside `lead` so
   * `applicationCta`/`postLeadCta` fieldMap entries like
   * `partnerIdentifiers.studentId` can resolve. Absent before the lead is
   * submitted.
   */
  partnerIdentifiers?: Record<string, string>;
  /**
   * Forwarded to the `EXIT_STRATEGY` step as `showCloseButton`. The
   * popup render target (`LeadFlowProvider`'s `'inline'` mode) sets this
   * so its exit strategy shows a top-right "x"; the drawer render
   * target leaves it unset since the drawer already owns a close
   * control.
   */
  showExitStrategyCloseButton?: boolean;
};
